const navLinks = [
  {
    id: 1,
    path: '/',
    text: 'Home',
    pageName: 'homePage',
  },
  {
    id: 2,
    path: '/aboutPage',
    text: 'About',
    pageName: 'aboutPage',
  },
  {
    id: 3,
    path: '/servicePage',
    text: 'Services',
    pageName: 'servicePage',
  },
  {
    id: 4,
    path: '/projectsPage',
    text: 'Projects',
    pageName: 'projectsPage',
  },
  {
    id: 4,
    path: '/contactPage',
    text: 'Contact',
    pageName: 'contactPage',
  },
];

export default navLinks;
